export default {
  TableHeadSecretPassword: [
    [
      {
        displayName: 'secretpass.table.source',
      },
      {
        displayName: 'secretpass.table.username',
      },
      {
        displayName: 'secretpass.table.role',
      },
      {
        displayName: 'secretpass.table.edit',
      },
      {
        displayName: 'secretpass.table.log',
      },
    ],
  ],
};
